import React from "react";
import Button from "./Button";
import { useNavigate } from "react-router-dom";

const PricingCard = ({
  title,
  price,
  duration,
  description,
  buttonText,
  isPopular,
  buttonType,
}) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (buttonType === "book") {
      navigate("/how-it-works");
    } else if (buttonType === "contact") {
      navigate("/contact");
    }
  };

  return (
    <div
      className={`
        bg-dark border border-light/10 rounded-xl p-6 flex flex-col h-full 
        transition-all duration-300 ease-in-out transform-gpu group
        hover:border-accent/50 hover:shadow-xl hover:shadow-accent/15 
        hover:scale-[1.03] hover:-translate-y-1
        ${
          isPopular
            ? "relative overflow-hidden border-accent/30 bg-gradient-to-b from-dark to-dark/80"
            : "before:absolute before:inset-0 before:bg-gradient-to-br before:from-accent/5 before:to-transparent before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-300 before:rounded-xl overflow-hidden"
        }
      `}
    >
      {isPopular && (
        <div className="absolute -right-10 top-5 bg-accent text-dark font-bold py-1 px-8 transform rotate-45 w-28 text-center shadow-md">
          Popular
        </div>
      )}
      <div className="mb-4 relative">
        <h3 className="text-xl font-bold text-light mb-2 transition-colors duration-300">
          {title}
        </h3>
        <div className="flex items-end mb-4">
          {title === "Standard Engagement" ? (
            <div className="flex flex-wrap items-baseline">
              <span className="text-3xl font-bold text-accent transition-all duration-300 group-hover:text-accent/100 group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_rgba(74,144,226,0.5)]">
                {price}
              </span>
              <span className="text-light/70 ml-2 text-sm transition-all duration-300 group-hover:text-light/90">
                / {duration}
              </span>
            </div>
          ) : (
            <>
              <span className="text-3xl font-bold text-accent transition-all duration-300 group-hover:text-accent/100 group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_rgba(74,144,226,0.5)]">
                {price}
              </span>
              {duration && (
                <span className="text-light/70 ml-2 text-sm transition-all duration-300 group-hover:text-light/90">
                  / {duration}
                </span>
              )}
            </>
          )}
        </div>
      </div>

      <div className="flex-grow mb-6 relative">
        <p className="text-light/70 transition-all duration-300 group-hover:text-light/90">
          {description}
        </p>
      </div>

      <Button
        onClick={handleButtonClick}
        primary={isPopular}
        className="w-full transition-all duration-300 hover:shadow-lg hover:shadow-accent/20 hover:translate-y-[-2px] z-10 relative"
      >
        {buttonText}
      </Button>
    </div>
  );
};

const PricingCards = () => {
  const pricingOptions = [
    {
      id: 1,
      title: "Free Introductory Call",
      price: "Free",
      duration: "15 minutes",
      description:
        "A brief discovery call to discuss your goals and explore how we might work together. This helps ensure mutual alignment before committing to any engagement.",
      buttonText: "Book Now",
      buttonType: "book",
      isPopular: false,
    },
    {
      id: 2,
      title: "Focused Strategy Session",
      price: "$75",
      duration: "30 minutes",
      description:
        "A dedicated consultation providing immediate insights and strategic advice on your specific challenges. Perfect for targeted problem-solving and actionable recommendations.",
      buttonText: "Book Now",
      buttonType: "book",
      isPopular: false,
    },
    {
      id: 3,
      title: "Standard Engagement",
      price: "From $125",
      duration: "per hour",
      description:
        "Flexible, hourly support for ongoing projects or advisory needs. Time and materials basis allows for scalable engagement across various technology and strategic initiatives.",
      buttonText: "Contact for Quote",
      buttonType: "contact",
      isPopular: false,
    },
    {
      id: 4,
      title: "Fixed-Fee Projects",
      price: "Custom Quote",
      duration: null,
      description:
        "Well-defined deliverables with predictable budgeting. Ideal for larger initiatives with clear scope and requirements where budget certainty is important.",
      buttonText: "Contact for Quote",
      buttonType: "contact",
      isPopular: false,
    },
  ];

  return (
    <div className="py-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {pricingOptions.map((option) => (
          <PricingCard key={option.id} {...option} />
        ))}
      </div>
    </div>
  );
};

export default PricingCards;
